import React from 'react';
import { Block, BLOCKS, Inline } from '@contentful/rich-text-types';

import { ILearningCenterAboutBlockFields } from '@/types/contentful';

import { BlockContainer, Column, Layout } from '../../../Layout';
import RichText from '../../../RichText';
import { ParagraphWithLineBreaks } from '../../../RichText/styles';

import { SearchBar } from '../SearchBar';
import { FeaturedPosts } from '../FeaturedPosts';

export function LearningCenterAbout({
  headingText,
  description,
  searchBar,
  newPopularArticles
}: ILearningCenterAboutBlockFields) {
  return (
    <BlockContainer
      marginTop="blockMargin"
      marginBottom="blockMargin"
      revealOnScroll={false}
      data-testid="lc-about"
    >
      <Layout gutter={{ tablet: 'l', desktop: '3xl' }}>
        <Column
          size={{ 0: 12, tablet: headingText || description ? 7 : 12 }}
          flexDirection="column"
        >
          {searchBar && (
            <div className="relative w-full">
              <div className="relative w-full">
                <SearchBar filters={searchBar.fields} />
              </div>
            </div>
          )}
          {(headingText || description) && (
            <div className="mt-12 grid gap-6 px-4 pb-8 pt-2 desktop:mt-24">
              <h2 className="heading-2 font-medium">{headingText}</h2>

              {description && (
                <div>
                  <RichText
                    data={description}
                    overrideOptions={{
                      [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
                        <ParagraphWithLineBreaks
                          as="p"
                          fontSize={{
                            0: 'sm',
                            tablet: 'ml'
                          }}
                          fontWeight="400"
                          colour="defaultText"
                        >
                          {children}
                        </ParagraphWithLineBreaks>
                      )
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </Column>

        {newPopularArticles && (
          <Column size={{ 0: 12, tablet: 5 }} justifyContent={'center'}>
            <FeaturedPosts {...newPopularArticles?.fields} />
          </Column>
        )}
      </Layout>
    </BlockContainer>
  );
}
